import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-section" }
const _hoisted_2 = { class: "form-section" }
const _hoisted_3 = { class: "form-section" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["name", "value", "onInput", "onBlur"]
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = ["name", "value", "onInput", "onBlur"]
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = {
  key: 0,
  class: "form-section"
}
const _hoisted_11 = {
  key: 0,
  class: "form-section"
}
const _hoisted_12 = {
  key: 1,
  class: "form-section"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}

import { computed, watch } from "vue";
import BaseModal from "../../../../room-booking-management/calendar/components/BaseModal.vue";
import BookingTypeSelector from "../../../../room-booking-management/calendar/components/BookingTypeSelector.vue";
import BookingRoomSelector from "../../../../room-booking-management/calendar/components/BookingRoomSelector.vue";
import BookingDateTime from "../../../../room-booking-management/calendar/components/BookingDateTime.vue";
import BookingPatternSelector from "../../../../room-booking-management/calendar/components/BookingPatternSelector.vue";
import RecurrenceSelector from "../../../../room-booking-management/calendar/components/RecurrenceSelector.vue";
import CancellationDatesManager from "../../../../room-booking-management/calendar/components/CancellationDatesManager.vue";
import CourseAppointmentEmployeeSelector from "./CourseAppointmentEmployeeSelector.vue";
import { useCourseAppointmentForm } from "../composables/useCourseAppointmentForm";


export default {
  __name: 'CourseAppointmentModal',
  props: {
	show: { type: Boolean, default: false },
	mode: { type: String, default: "create" },
	appointment: { type: Object, default: null },
	series: { type: Object, default: null },
	saving: { type: Boolean, default: false },
	lecturePeriodStart: { type: String, default: null },
	lecturePeriodEnd: { type: String, default: null },
	employeeSearchApiUrl: { type: String, default: null },
	defaultTitle: { type: String, default: "" },
	defaultEmployeeId: { type: Number, default: null },
	defaultEmployeeName: { type: String, default: "" },
	nonTeachingDates: { type: Object, default: () => ({}) },
},
  emits: ["close", "submit"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasNonTeachingDates = computed(
	() => props.nonTeachingDates && Object.keys(props.nonTeachingDates).length > 0
);

const { form, modalTitle, populateForm } = useCourseAppointmentForm(props, emit);

// Always include the currently selected room in the room selector (edit mode).
const currentRoomId = computed(
	() => props.appointment?.roomId || props.series?.roomId || null
);

function showRecurrence(values) {
	if (props.mode === "edit-series") {
		return true;
	}
	if (props.mode === "create") {
		return !!(values.rrulePattern && values.rrulePattern.trim());
	}
	return false;
}

watch(
	() => props.show,
	(isShowing) => {
		if (isShowing) {
			populateForm();
		}
	},
	{ immediate: true }
);

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: _unref(modalTitle),
    size: "lg",
    "modal-id": "courseAppointmentModal",
    "is-loading": __props.saving,
    onClose: _cache[3] || (_cache[3] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("form", {
        class: "booking-form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers($event => (_unref(form).handleSubmit()), ["prevent","stop"]))
      }, [
        _createCommentVNode(" Room "),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BookingRoomSelector, {
            form: _unref(form),
            "current-room-id": currentRoomId.value,
            "allow-empty": ""
          }, null, 8 /* PROPS */, ["form", "current-room-id"])
        ]),
        _createCommentVNode(" Booking type "),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BookingTypeSelector, {
            form: _unref(form),
            mode: __props.mode
          }, null, 8 /* PROPS */, ["form", "mode"])
        ]),
        _createCommentVNode(" Title & Description (title pre-filled with the course name, editable) "),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(form).Field, { name: "title" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "caTitle",
                  class: "form-label"
                }, "Titel", -1 /* CACHED */)),
                _createElementVNode("input", {
                  id: "caTitle",
                  type: "text",
                  name: field.name,
                  value: field.state.value,
                  class: "form-control",
                  onInput: (e) => field.handleChange(e.target.value),
                  onBlur: field.handleBlur
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_unref(form).Field, { name: "description" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  for: "caDescription",
                  class: "form-label"
                }, "Beschreibung", -1 /* CACHED */)),
                _createElementVNode("textarea", {
                  id: "caDescription",
                  name: field.name,
                  value: field.state.value,
                  class: "form-control",
                  rows: "3",
                  onInput: (e) => field.handleChange(e.target.value),
                  onBlur: field.handleBlur
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7)
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createCommentVNode(" Fremdbuchung: lecturer/employee the appointment is booked for (pre-filled, editable) "),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CourseAppointmentEmployeeSelector, {
            form: _unref(form),
            "employee-search-api-url": __props.employeeSearchApiUrl
          }, null, 8 /* PROPS */, ["form", "employee-search-api-url"])
        ]),
        _createCommentVNode(" Date & time "),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BookingDateTime, {
            form: _unref(form),
            show: __props.show,
            "can-ignore-opening-hours": false
          }, null, 8 /* PROPS */, ["form", "show"])
        ]),
        _createCommentVNode(" Pattern selection (only when creating) "),
        (__props.mode === 'create')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(BookingPatternSelector, {
                form: _unref(form),
                mode: __props.mode
              }, null, 8 /* PROPS */, ["form", "mode"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Recurrence + cancellation management "),
        _createVNode(_unref(form).Subscribe, null, {
          default: _withCtx(({ values }) => [
            (showRecurrence(values))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(RecurrenceSelector, { form: _unref(form) }, null, 8 /* PROPS */, ["form"])
                ]))
              : _createCommentVNode("v-if", true),
            (showRecurrence(values))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(CancellationDatesManager, {
                    form: _unref(form),
                    "rrule-pattern": values.rrulePattern,
                    "start-date": values.startDate,
                    "start-time": values.startTime,
                    "non-teaching-dates": __props.nonTeachingDates,
                    "enable-exclusions": hasNonTeachingDates.value,
                    "exclusions-default-on": __props.mode === 'create'
                  }, null, 8 /* PROPS */, ["form", "rrule-pattern", "start-date", "start-time", "non-teaching-dates", "enable-exclusions", "exclusions-default-on"])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ], 32 /* NEED_HYDRATION */)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: __props.saving,
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
      }, " Abbrechen ", 8 /* PROPS */, _hoisted_13),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: __props.saving,
        onClick: _cache[2] || (_cache[2] = $event => (_unref(form).handleSubmit()))
      }, [
        (__props.saving)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15))
          : _createCommentVNode("v-if", true),
        _cache[6] || (_cache[6] = _createTextVNode(" Speichern ", -1 /* CACHED */))
      ], 8 /* PROPS */, _hoisted_14)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title", "is-loading"]))
}
}

}